import { render, staticRenderFns } from "./LimitedTextArea.vue?vue&type=template&id=74106466&"
import script from "./LimitedTextArea.vue?vue&type=script&lang=js&"
export * from "./LimitedTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports